/*
 * NOTIFBAR
 * --------
 *  To pass informations to the reader
 *      - such as mdp for captcha
 *      - infos during chat ?
 */

import { makeUnselectable, Fade } from '@js/utils'
import { NotifbarOptions } from '@js/types'
import css from '@css/sass/styles.module.scss'

export class Notifbar {
  private box: HTMLDivElement | null
  private boxText: HTMLHeadingElement | null 
  private timeout: number
  private fadein: number
  private fadeout: number

  constructor (options: NotifbarOptions) {
    options.object = this
    this.timeout = options.timeout || 30000 // (ms)
    this.fadein = options.fadein || 200     // (ms)
    this.fadeout = options.fadeout || 500   // (ms)
    this.box = null
    this.boxText = null
  }

  setup() {
    this.box = document.createElement('div')
    document.body.appendChild(this.box)
    this.box.id = css.notifbar
    makeUnselectable(this.box)
    this.boxText = document.createElement('h2')
    this.box.appendChild(this.boxText)

    console.debug('[Notifbar] set up')
  }

  display(text: string) {
    if (!this.box || !this.boxText) return
    Fade.fadeIn(this.box, this.fadein)
    this.boxText.innerHTML = text
    this.hide()
  }

  hide() {
    if (!this.box) return
    Fade.fadeOutWithDelay(this.box, this.fadeout, this.timeout)
  }
}

